import React, { useRef, useState, useEffect } from 'react'
import classnames from 'classnames'
import Link from 'next/link'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { getZT } from 'lib/zt-util'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import { IPageConfig } from './popular-model'
import SwiperButton from 'Components/swiper-button'
SwiperCore.use([Navigation])

interface IProps {
  hotBrand: any
  responsiveType: any
  nav: any
}

// 汽车分类配置
const CAR_MAX = 27
export const pageConfig: IPageConfig = {
  sm: {
    size: 4,
    page: 7,
  },
  md: {
    size: 5,
    page: 6,
  },
  lg: {
    size: 5,
    page: 6,
  },
  xl: {
    size: 7,
    page: 4,
  },
  '2xl': {
    size: 9,
    page: 3,
  },
}

export default function RenderCarList({
  carData = [],
  type = '',
  index = 0,
}: {
  [key: string]: any
}) {
  const [isEnd, setIsEnd] = useState(false)
  const [swiper, setSwiper] = useState<any>(null)
  const navigationPrevRef = React.useRef(null)
  const navigationNextRef = React.useRef(null)

  useEffect(() => {
    setIsEnd(false)
    if (swiper && swiper.slideTo) {
      swiper.slideTo(0)
    }
  }, [carData])

  const breakpoints = {
    1280: {
      slidesPerView: 5,
      slidesPerGroup: 5,
    },
    1680: {
      slidesPerView: 7,
      slidesPerGroup: 7,
    },
    1920: {
      slidesPerView: 9,
      slidesPerGroup: 9,
    },
  }

  return (
    <div>
      {carData?.length && (
        <Swiper
          spaceBetween={12}
          watchOverflow={true}
          slidesPerGroup={4}
          slidesPerView={4}
          breakpoints={breakpoints}
          preventClicks={false}
          navigation={{
            nextEl: navigationNextRef.current,
            prevEl: navigationPrevRef.current,
          }}
          onSwiper={setSwiper}
          simulateTouch={false}
          loop={false}
          onSlideChangeTransitionStart={(swiper) => {
            setIsEnd && setIsEnd(swiper.isEnd)
            sendTeaCommEvent('clk_event', {
              event_id: 'select_module_switch_btn',
              module_id: 'select_module',
            })
          }}
        >
          <div className="list-item-wrap">
            {carData.map((item: any, i: number) => {
              return (
                <SwiperSlide key={`swiper-${i}`}>
                  {RenderCarBox(item, i)}
                </SwiperSlide>
              )
            })}
          </div>
          <SwiperButton
            ref={navigationPrevRef}
            type="prev"
            theme="gray"
            buttonStyle={{
              position: 'absolute',
              left: '4px',
              top: '7px',
              zIndex: 9,
            }}
          />
          <SwiperButton
            ref={navigationNextRef}
            type="next"
            theme="gray"
            buttonStyle={{
              position: 'absolute',
              right: '1px',
              top: '7px',
              zIndex: 9,
            }}
            className={classnames({
              'tw-hidden': isEnd,
            })}
          />
          <span
            className={classnames({
              'cus-button-next-click': true,
              'tw-hidden': !isEnd,
            })}
          >
            <Link
              href={`/auto/library/x-${type}-x-x-x-x-x-x-x-x-x`}
              as={`/auto/library/x-${type}-x-x-x-x-x-x-x-x-x`}
            >
              <a
                target="_blank"
                className="g-active-link-text"
                // onClick={() => {
                //   sendTeaCommEvent('select_module_switch_btn', {

                //   })
                // }}
              >
                更多
              </a>
            </Link>
          </span>
        </Swiper>
      )}
      <style jsx>
        {`
          .list-item-wrap {
            display: flex;
            padding: 0 10px;
          }
          .model {
            flex: 1;
            padding: 0 3px;
          }
          .name-wrapper {
            display: flex;
            justify-content: center;
            width: 100%;
            position: relative;
            text-align: center;
            height: 22px;
            line-height: 22px;
          }
          .series-name {
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            word-break: break-all;
          }
          .series-name:hover {
            color: #e62021;
          }
          .tag {
            position: relative;
            display: inline-block;
            padding: 0 2px;
            height: 14px;
            margin-left: 4px;
            top: 3px;
            line-height: 14px;
            font-size: 10px;
            color: #ffffff;
            border-radius: 2px;
            background-color: #fa5555;
          }
        `}
      </style>
    </div>
  )
}

/* 渲染报价图库参数 */

function SeriesDetail({
  seriesId,
  name,
  carIds,
  onClick,
}: {
  seriesId: number
  name: string
  carIds: string[] | number[]
  onClick?(): void
}) {
  return (
    <div
      onClick={() => {
        onClick && onClick()
      }}
    >
      <ul>
        <li>
          <Link
            href={`/dealer?seriesId=${seriesId}&zt=${getZT(
              'pc_home_top_series'
            )}`}
            as={`/dealer/${seriesId}?zt=${getZT('pc_home_top_series')}`}
          >
            <a
              target="_blank"
              title={name}
              onClick={() => {
                sendTeaCommEvent('clk_event', {
                  event_id: 'select_module_series_cell_btn',
                  car_series_id: `${seriesId}`,
                  car_series_name: name,
                  button_name: '询价',
                  module_id: 'select_module',
                })
              }}
            >
              <span className="name line-1">询价</span>
            </a>
          </Link>
        </li>
        <li>
          <Link
            href={`/auto/images/detail?category=wg&seriesId=${seriesId}`}
            as={`/auto/series/${seriesId}/images/wg-x-x-x`}
          >
            <a
              target="_blank"
              title={name}
              onClick={() => {
                sendTeaCommEvent('clk_event', {
                  event_id: 'select_module_series_cell_btn',
                  car_series_id: `${seriesId}`,
                  car_series_name: name,
                  button_name: '图库',
                  module_id: 'select_module',
                })
              }}
            >
              <span className="name line-1">图库</span>
            </a>
          </Link>
        </li>
        <li>
          <Link href={`/community/${seriesId}`} as={`/community/${seriesId}`}>
            <a
              target="_blank"
              title={name}
              onClick={() => {
                sendTeaCommEvent('clk_event', {
                  event_id: 'select_module_series_cell_btn',
                  car_series_id: `${seriesId}`,
                  car_series_name: name,
                  button_name: '车友圈',
                  module_id: 'select_module',
                })
              }}
            >
              <span className="name line-1">车友圈</span>
            </a>
          </Link>
        </li>
      </ul>
      <style jsx>
        {`
          .name.line-1 {
            color: #969aa9;
          }
          .name.line-1:hover {
            @apply tw-text-common-orange;
          }
          ul {
            height: 18px;
            line-height: 18px;
            font-size: 12px;
            display: flex;
            width: 92px;
            justify-content: space-around;
            margin: 2px auto;
            color: #999999;
          }
          li {
            padding: 0 4px;
            position: relative;
          }
          li:first-child {
            padding-left: 0;
          }

          li:not(:last-child)::after {
            content: '';
            top: 4px;
            right: 0;
            background-color: #cccccc;
            height: calc(100% - 8px);
            width: 1px;
            position: absolute;
          }
        `}
      </style>
    </div>
  )
}

export function RenderCarBox(item: any, index: number) {
  const name =
    item.outter_name ||
    item.series_name ||
    item.info.series_name ||
    item.info.brand_name
  return (
    <div className="series model" key={`box-${index}`}>
      <Link
        href={`/auto/series?seriesId=${item.id || item.info.series_id}`}
        as={`/auto/series/${item.id || item.info.series_id}`}
      >
        <a
          target="_blank"
          title={name}
          onClick={() => {
            sendTeaCommEvent('clk_event', {
              event_id: 'select_module_series_cell_top',
              car_series_id: `${item.id}`,
              car_series_name: name || item.info.series_name,
              module_id: 'select_module',
            })
          }}
        >
          <div className="name-wrapper g-active-link-text">
            <span className="series-name g-active-link-text">{name}</span>
            {item.new_car_tag === 1 ? <span className="tag">新</span> : ''}
          </div>
        </a>
      </Link>
      <SeriesDetail
        name={name}
        carIds={item.car_ids}
        seriesId={item.id || item.info.series_id}
      />
      <style jsx>
        {`
          .list-item-wrap {
            display: flex;
            padding: 0 10px;
          }
          .model {
            flex: 1;
            padding: 0 3px;
          }
          .name-wrapper {
            display: flex;
            justify-content: center;
            width: 100%;
            position: relative;
            text-align: center;
            height: 22px;
            line-height: 22px;
          }
          .series-name {
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            word-break: break-all;
            transition: all 0.3s ease-in-out;
          }
          .series-name:hover {
            color: #e62021;
          }
          .tag {
            position: relative;
            display: inline-block;
            padding: 0 4px;
            height: 19px;
            margin-left: 4px;
            top: 2px;
            line-height: 19px;
            font-size: 10px;
            color: #ffffff;
            border-radius: 2px;
            background-color: #e65800;
            font-size: 12px;
            transform: scale(0.8);
          }
        `}
      </style>
    </div>
  )
}
